import React from "react";
import { connect } from 'react-redux';
import { reduxForm, Field } from 'redux-form';
import { UnstiledDropdownListField } from '../common/Inputs';
import { Panel, Button, Alert } from 'react-bootstrap';
import {
    getSettings,
    updateSettings,
    clearUpdateSettings
} from "../../actions/settings";
import * as fetchingState from '../../constants/fetchingState';
import * as permissions from '../../constants/permissions';

import { popularity } from '../../constants/settingTypes';

const validate = ({ Period, UpdateFrequency }) => {
    const errors = {};

    if (Period < 1 || Period > 365)
        errors.Period = "*Период должен быть в пределах от 1 до 365.";

    if (UpdateFrequency < 1 || UpdateFrequency > 24)
        errors.UpdateFrequency = "*Частота обновления должна быть в пределах от 1 до 24";

    return errors;
}

const getPeriodOptions = () => {
    const options = [];
    for (let i = 1; i <= 365; i++) {
        options.push({ name: `${i} д.`, value: i });
    }
    return options;
}

const getUpdateFrequencyOptions = () => {
    const options = [];
    for (let i = 1; i <= 24; i++) {
        options.push({ name: `${i} ч.`, value: i });
    }
    return options;
}

const normalize = (value, previousValue) => value ? value.value : previousValue;

let Popularity = class extends React.Component {
    constructor(props) {
        super(props);

        this._onSubmit = this._onSubmit.bind(this);
        this._resetForm = this._resetForm.bind(this);
        this._load = this._load.bind(this);
    }

    _onSubmit(values) {
        this.props.updateSettings(popularity, values);
    }

    _resetForm() {
        this.props.clearUpdateSettings(popularity);
    }

    _load() {
        this.props.clearUpdateSettings(popularity);
        this.props.getSettings(popularity);
    }

    componentDidMount() {
        this.props.getSettings(popularity);
    }

    render() {
        const { handleSubmit, fetching, updateFetching, crudError } = this.props;
        const formVisible = fetching === fetchingState.FETCHED && updateFetching === fetchingState.INITIAL;
        const isReadOnly = !permissions.isAllowedFor(permissions.allowedEditSettings);
        return (
            <Panel>
                <Panel.Heading>Настройки ротатора</Panel.Heading>
                <Panel.Body>
                    {formVisible && <form className='form-horizontal'>
                        <div>
                            <Field name='Period' disabled={isReadOnly} data={getPeriodOptions()} valueField='value' textField='name' component={UnstiledDropdownListField} label='Период' normalize={normalize} />
                            <Field name='UpdateFrequency' disabled={isReadOnly} data={getUpdateFrequencyOptions()} valueField='value' textField='name' component={UnstiledDropdownListField} label='Частота обновления' normalize={normalize} />
                        </div>
                        <div style={{ margin: '5px', marginTop: '14px', float: 'right' }}>
                            <Button disabled={isReadOnly} bsStyle="success" type="submit" onClick={handleSubmit(this._onSubmit)}>Сохранить</Button>
                        </div>
                    </form>}
                    {fetching === fetchingState.FETCHING && <Alert bsStyle='info'>Загрузка...</Alert>}
                    {fetching === fetchingState.FAILED && <Alert bsStyle='danger'>Ошибка загрузки</Alert>}
                    {updateFetching === fetchingState.FETCHING && <Alert bsStyle='info'>Пожалуйста, подождите...</Alert>}
                    {updateFetching === fetchingState.FETCHED && <div>
                        <Alert bsStyle='success'>Настройки успешно обновлены</Alert>
                        <Button bsStyle="primary" onClick={this._resetForm}>Закрыть</Button>
                    </div>}
                    {updateFetching === fetchingState.FAILED && <div>
                        <Alert bsStyle='danger'>
                            <p>ОШИБКА!</p>
                            {crudError && <p>{crudError}</p>}
                        </Alert>
                        <Button onClick={this._load}>Закрыть</Button>
                    </div>}
                </Panel.Body>
            </Panel>);
    }
}

Popularity = reduxForm({
    form: 'popularitySettingsEdit',
    validate,
    enableReinitialize: true
})(Popularity);

Popularity = connect(state => {
    const { data, fetching, updateFetching } = state.application.get('settings')[popularity];
    return { initialValues: data, fetching, updateFetching }
}, {
    getSettings,
    updateSettings,
    clearUpdateSettings
})(Popularity);

export default Popularity;


// WEBPACK FOOTER //
// ./src/components/settings/Popularity.jsx